const CONTRACT_URL = '/verejne-zakazky'
const EKOM_BASE_URL = '/ekomunikace'

export const EKOM_LINKS = {
  base: EKOM_BASE_URL,
  listSent: EKOM_BASE_URL + '/odeslane-zpravy',
  listRecv: EKOM_BASE_URL + '/prijate-zpravy',
  listSubmissions: EKOM_BASE_URL + '/podani',
  contractDetail: CONTRACT_URL,
  contractVirtual: EKOM_BASE_URL + '/externi-zakazka',
  newMsg: EKOM_BASE_URL + '/nova-zprava',
  newSubms: EKOM_BASE_URL + '/nove-podani',
  newMsgVirtual: EKOM_BASE_URL + '/nova-zprava-externi',
  newSubmsVirtual: EKOM_BASE_URL + '/nove-podani-externi',
  queryResponseId: 'odpovedNa',
  queryResponseSuject: 'odpovedNaPredmet',
  queryExtSys:'extSys',
  queryExtId: 'extId'
}
